<template>
  <v-app>
    <nav-bars></nav-bars>

    <transition name="fade">
      <v-main class="background">

        <router-view></router-view>

      </v-main>
    </transition>
    <v-overlay :value="loading">

    </v-overlay>
    <snackbar/>
    <login-dialog/>
  </v-app>
</template>

<script>
  import NavBars from "./NavBars"
  import Snackbar from "./Snackbar"
  import LoginDialog from "./LoginDialog"
  import {mapActions, mapGetters} from 'vuex'

  export default {

    components: {
      NavBars,
      Snackbar,
      LoginDialog
    },
    computed: {
      ...mapGetters({
        loading: 'shared/getLoading'
      })
    },
    methods: {
      ...mapActions({
        bootstrapAuth: 'auth/bootstrap'
      })
    },
    created() {
      this.bootstrapAuth()
    }
  }
</script>


<style>
* {
  scrollbar-width: thin;
  scrollbar-color: hsl(134, 61%, 35%) #eeeeee3a;
}
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
*::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
*::-webkit-scrollbar-thumb {
  background: hsl(134, 61%, 35%);
  border: 0px none #ffffff;
  border-radius: 0px;
}
*::-webkit-scrollbar-thumb:hover {
  background: hsl(134, 61%, 28%);
}
*::-webkit-scrollbar-thumb:active {
  background: hsl(134, 61%, 20%);
}
*::-webkit-scrollbar-track {
  background: transparent;
  border: 0px none #ffffff;
  border-radius: 50px;
}
*::-webkit-scrollbar-track:hover {
  background: transparent;
}
*::-webkit-scrollbar-track:active {
  background: transparent;
}
*::-webkit-scrollbar-corner {
  background: transparent;
}

html {
  overflow-y: auto;
}
.apexcharts-toolbar {
  z-index: 0 !important;
}
.v-btn__content {
  max-width: 110%;
}

/* оборачиваем v-data-table div.v-data-table-off-overflow
  только так нормально фиксированный хедер работает */
.v-data-table-off-overflow .v-data-table__wrapper{
  overflow: inherit !important;
}
</style>